import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Tooltip
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { HouseBank } from "../../../models/HouseBank";
import {
  VendorBankDetail,
  VendorDetailState,
} from "../../../reducers/vendor/VendorDetailReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorDetailBankDetailMeta } from "../../../models/VendorDetail/VendorDetailBankDetailMeta";
import FileUpload from "../../../components/FileUpload/FileUpload";
import {
  DropdownOptions,
  DropdownOptions_VendorDetail_BankName,
  DropdownOptions_VendorDetail_BankNumber,
  VendorRequestViewMode,
  VendorCountry,
  RequestStatus,
  FieldsLengthConstants,
  NatureOfBusiness,
} from "../../../constants/AppConstants";
import { RoleUtil } from "../../../utils/RoleUtil";
import { FileUploadTypes } from "../../../constants/AppConstants";
import { BankDetails } from "../../../models/BankDetails";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import { SortCode } from "../../../models/SortCode";
import { VendorAmendService } from "../../../services/VendorAmendService";
import VendorDetail from "./VendorDetail";
import { Common } from "../../../utils/Common";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Country } from "../../../models/Country";
import BankDetailDialog from "../../../components/Vendor/Popup/BankDetailDialog";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/Visibility";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import { Util } from "../../../utils/Util";
import { PurposeOfPayment } from "../../../models/PurposeOfPayment";
import { CurrencyHouseBank } from "../../../models/AccCurency";

export default function BankDetail(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    getErrorState,
    handleChange,
    housebanks,
    purposelist,
    countries,
    isEditableMode,
    handleOnBlur,
    getCompareField,
    getBankGridCompareField,
    currencyHouseBanks,
    selectedHouseBanks
  } = props;

  const [openBankDialog, setOpenBankDialog] = useState(false);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  let initialStateBankDetail: VendorBankDetail = {
    id: 0,
    bankCountry: vendorDetail.AddressCoutry,
    beneficiaryAccName: Util.getBankNameFromVendorName(vendorDetail),
    noObjectionLetterFile: { fileId: 0, fileName: "", filePath: "" },
    beneficiaryAddress: vendorDetail.AddressNumberStreet,
    bankAccNumber: "",
    bankStatementFile: { fileId: 0, fileName: "", filePath: "" },
    bankConfirmationFile: { fileId: 0, fileName: "", filePath: "" },
    bankACKey: "",
    bankAcKeyDesc: "",
    accCurrency: "",
    bankName: "",
    bankAddress: "",
    sortCode: "",
    swiftCode: "",
    ibanCode: "",
    bankNumber: "",
    bankBranch: "",
    modifiedStatus: 0
  };

  const [selectedBankData, setSelectedBankData] = useState<VendorBankDetail>(initialStateBankDetail);
  const [isAddBankData, setIsAddBankData] = useState(false);

  const tableColumnData = [
    { name: translation.vendor_detail_bankdetails_bankcounry_lbl },
    { name: translation.vendor_detail_bankdetails_bacontnm_lbl },
    { name: translation.vendor_detail_bankdetails_badress_lbl },
    { name: translation.vendor_detail_bankdetails_bankacnum_lbl },
    { name: translation.vendor_detail_bankdetails_bankkey_lbl },
    { name: translation.vendor_detail_bankdetails_accurency_lbl },
    { name: translation.vendor_detail_bankdetails_bankname_lbl },
    { name: translation.vendor_detail_bankdetails_bankad_lbl },
    { name: translation.vendor_detail_bankdetails_swiftcd_lbl },
    { name: translation.vendor_detail_bankdetails_ibancode_lbl },
    { name: translation.vendor_detail_bankdetails_bankbranch_lbl },
    { name: translation.vendor_detail_bankdetails_banknum_lbl }
  ];

  const getRowColorClass = (row: VendorBankDetail) => {
    if (row.modifiedStatus == 1) {
      return classes.addedStripe;
    }
    else if (row.modifiedStatus == 2) {
      return classes.deletedStripe;
    }
    else if (row.modifiedStatus == 3) {
      return classes.modifiedStripe;
    }
  };

  const getAllowedCountries = () => {
    if(countries && countries.length > 0){
      //HK
      if(vendorDetail.AddressCoutry == 'HK' || vendorDetail.AddressCoutry == 'CN'){
        return countries.filter((c:any) => c.code == 'HK' || c.code == 'CN');
      }
      return countries.filter((c:any) => c.code == vendorDetail.AddressCoutry);
    }
    return [];
  };

  const handleAddBankDetails = () => {
    setSelectedBankData(initialStateBankDetail);
    setIsAddBankData(true);
    setOpenBankDialog(true);
  };

  const handleBankDetailClose = (e: any) => {
    setSelectedBankData(initialStateBankDetail);
    setOpenBankDialog(false);
  };

  const onBankDetailEditClick = (listItem: VendorBankDetail) => {
    setSelectedBankData(listItem);
    setIsAddBankData(false);
    setOpenBankDialog(true);
  };

  const onBankDetailDeleteClick = (listItem: VendorBankDetail) => {
    dispatch(
      AllActions.alertDialogActions.openAlertDialog(
        translation.vendor_detail_bankdetails_remove_con_title,
        translation.vendor_detail_bankdetails_remove_con_msg,
        translation.vendor_detail_bankdetails_remove_con_yesbtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
          dispatch(AllActions.vendorDetailActions.removeBankDetails(listItem));
        },
        translation.vendor_detail_bankdetails_remove_con_nobtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
        }
      )
    );
  };

  return (
    <div>
      <Grid container spacing={2} item xs={12} sm={12} md={11} lg={12}>
        <Grid container
          spacing={2}
          item
          xs={12}
          sm={12}
          md={11}
          lg={12}
          className={classes.formOneWrapper}
        >
          {vendorDetail.isIndividualPayement &&
            <Grid
              hidden={!RoleUtil.isSBUFinance()}
              item
              xs={12}
              sm={12}
              md={6}
              lg={4}
              className={!isEditableMode ? classes.compDisableCls : ""}
            >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.formTwoLbl}>
                  {translation.individualPayPopup_payement_currency_lbl}
                </span>
              </Grid>
              <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12}>
                {isEditableMode &&
                  <Select
                    variant="outlined"
                    value={vendorDetail.currencyId || 0}
                    onChange={handleChange("currencyId")}
                    error={getErrorState("currencyId")}
                  >
                    {currencyHouseBanks.map((obj: CurrencyHouseBank, index: number) => (
                      <MenuItem key={index} value={obj.currencyCode}>
                        {obj.currencyCode}
                      </MenuItem>
                    ))}
                  </Select>
                }
                {!isEditableMode &&

                  <Grid
                    className={classes.formOneinputWrapper}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                  >
                    <span className={classes.textWrapInput}>{currencyHouseBanks.find((ele: CurrencyHouseBank) => ele.houseBank === vendorDetail.HouseBank) ?
                      currencyHouseBanks.find((e: CurrencyHouseBank) => e.houseBank === vendorDetail.HouseBank).currencyCode : ""}</span>

                  </Grid>
                }
              </Grid>
            </Grid>
          }
          {!vendorDetail.isIndividualPayement &&
            <Grid hidden={!RoleUtil.isSBUFinance()} item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.formTwoLbl}>
                  {translation.vendor_detail_bankdetails_housebank_lbl}
                  <label hidden={getCompareField("HouseBankCode")} className={classes.editedLabel}>EDITED</label>
                </span>
              </Grid>
              <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12}>
                <Select
                  //disabled={!isEditableMode}
                  variant="outlined"
                  value={vendorDetail.HouseBank || ""}
                  onChange={handleChange("HouseBank")}
                  error={getErrorState("HouseBank")}
                >
                  <MenuItem value="">
                    <em>{translation.dropdown_empty_text}</em>
                  </MenuItem>
                  {housebanks.map((obj: HouseBank, index: number) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          }
          {vendorDetail.isIndividualPayement &&
            <Grid hidden={!RoleUtil.isSBUFinance()} item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.formTwoLbl}>
                  {translation.vendor_detail_bankdetails_housebank_lbl}
                  <label hidden={getCompareField("HouseBankCode")} className={classes.editedLabel}>EDITED</label>
                </span>
              </Grid>
              <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12}>
                {isEditableMode &&
                  <Select
                    disabled={vendorDetail.isIndividualPayment}
                    variant="outlined"
                    value={vendorDetail.HouseBank || ""}
                    onChange={handleChange("HouseBank")}
                    error={getErrorState("HouseBank")}
                  >
                    {selectedHouseBanks.map((obj: CurrencyHouseBank, index: number) => (
                      <MenuItem key={index} value={obj.houseBank}>
                        {obj.houseBank}
                      </MenuItem>
                    ))}
                  </Select>
                }
                {!isEditableMode &&
                  <Grid
                    className={classes.formOneinputWrapper}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                  >
                    <span className={classes.textWrapInput}>
                      {vendorDetail.HouseBank}
                    </span>
                  </Grid>
                }
              </Grid>
            </Grid>
          }
          { !Common.isVendor() && (<Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_detail_bankdetails_reconac_lbl}
                <label hidden={getCompareField("ReconAcc")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <span className={classes.textWrapInput}>
                {vendorDetail.ReconAC}
              </span>
            </Grid>
          </Grid>)}
          { !Common.isVendor() && (<Grid hidden={Common.isVendor()} item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.approve_purposecode_lbl}
                <label hidden={getCompareField("PurposeCode")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <span className={classes.textWrapInput}>
                {vendorDetail.PurposeCode}
              </span>
            </Grid>
          </Grid>)}
          <Grid hidden={Common.isVendor() || (vendorDetail.AddressCoutry != VendorCountry.Indonesia ||
            vendorDetail.CompanyCode.countryCode != VendorCountry.Indonesia)} item xs={12} sm={12} md={6} lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.ho_beneficiaryCatIndo_lbl}
                <label hidden={getCompareField("HoBeneficiaryCatIndo")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper
            } item xs={12} sm={12} md={12} lg={12} >
              <TextField
                //disabled={!isEditableMode}
                variant="outlined"
                value={vendorDetail.HoBeneficiaryCatIndo || ""}
                onChange={handleChange("HoBeneficiaryCatIndo")}
                error={getErrorState("HoBeneficiaryCatIndo")}
                inputProps={{
                  maxLength: FieldsLengthConstants.HoBeneficiaryCatIndo,
                }}
                onBlur={handleOnBlur("HoBeneficiaryCatIndo")}
              />
            </Grid>
          </Grid>
          <Grid hidden={Common.isVendor() || (vendorDetail.AddressCoutry != VendorCountry.Indonesia ||
            vendorDetail.CompanyCode.countryCode != VendorCountry.Indonesia)} item xs={12} sm={12} md={6} lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.ho_purposeofTransIndo_lbl}
                <label hidden={getCompareField("HopurposeofTransIndo")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid className={
              (vendorDetail.AddressCoutry === VendorCountry.Indonesia &&
                vendorDetail.CompanyCode.countryCode == VendorCountry.Indonesia)
                ? classes.inputWrapper_Req
                : classes.formOneinputWrapper
            } item xs={12} sm={12} md={12} lg={12} >
              <TextField
                //disabled={!isEditableMode}
                variant="outlined"
                value={vendorDetail.HopurposeofTransIndo || ""}
                onChange={handleChange("HopurposeofTransIndo")}
                error={getErrorState("HopurposeofTransIndo")}
                inputProps={{
                  maxLength: FieldsLengthConstants.HoPurposeofTransIndo,
                }}
                onBlur={handleOnBlur("HopurposeofTransIndo")}
              />
            </Grid>
          </Grid>
          <Grid hidden={Common.isVendor() || (vendorDetail.AddressCoutry != VendorCountry.Indonesia ||
            vendorDetail.CompanyCode.countryCode != VendorCountry.Indonesia)} item xs={12} sm={12} md={6} lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.ho_beneAffiliationStatusIndoe_lbl}
                <label hidden={getCompareField("HoBeneAffiliationStatusIndo")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper
            } item xs={12} sm={12} md={12} lg={12} >
              <TextField
                //disabled={!isEditableMode}
                variant="outlined"
                value={vendorDetail.HoBeneAffiliationStatusIndo || ""}
                onChange={handleChange("HoBeneAffiliationStatusIndo")}
                error={getErrorState("HoBeneAffiliationStatusIndo")}
                inputProps={{
                  maxLength: FieldsLengthConstants.HoBeneAffiliationStatusIndo,
                }}
                onBlur={handleOnBlur("HoBeneAffiliationStatusIndo")}
              />
            </Grid>
          </Grid>
          <Grid hidden={Common.isVendor() || (vendorDetail.AddressCoutry != VendorCountry.India ||
            vendorDetail.CompanyCode.countryCode != VendorCountry.India)
          } item xs={12} sm={12} md={6} lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.ho_payableLocationIndia_lbl}
                <label hidden={getCompareField("HoPayableLocationIndia")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <TextField
                //disabled={!isEditableMode}
                variant="outlined"
                value={vendorDetail.HoPayableLocationIndia || ""}
                onChange={handleChange("HoPayableLocationIndia")}
                error={getErrorState("HoPayableLocationIndia")}
                inputProps={{
                  maxLength: FieldsLengthConstants.HoPayableLocationIndia,
                }}
                onBlur={handleOnBlur("HoPayableLocationIndia")}
              />
            </Grid>
          </Grid>
          <Grid hidden={Common.isVendor() || (vendorDetail.AddressCoutry != VendorCountry.India ||
            vendorDetail.CompanyCode.countryCode != VendorCountry.India)}
            item
            xs={12}
            sm={12}
            md={6}
            lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.ho_purposePayIndia_lbl}
                <label hidden={getCompareField("HoPurposePayIndia")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={
                (vendorDetail.AddressCoutry === VendorCountry.India &&
                  vendorDetail.CompanyCode.countryCode == VendorCountry.India)
                  ? classes.inputWrapper_Req
                  : classes.formOneinputWrapper
              }
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Select
                //disabled={!isEditableMode}
                variant="outlined"
                value={vendorDetail.HoPurposePayIndia || ""}
                onChange={handleChange("HoPurposePayIndia")}
                error={getErrorState("HoPurposePayIndia")}
              >
                <MenuItem value="">
                  <em>{translation.dropdown_empty_text}</em>
                </MenuItem>
                {purposelist.map((obj: PurposeOfPayment, index: number) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.code} - {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          {/* add company code */}
          <Grid hidden={Common.isVendor() ||
            !((vendorDetail.CompanyCode.countryCode == VendorCountry.Indonesia &&
              vendorDetail.AddressCoutry != VendorCountry.Indonesia) ||
              (vendorDetail.CompanyCode.countryCode == VendorCountry.Kenya &&
                vendorDetail.AddressCoutry != VendorCountry.Kenya))
          } item xs={12} sm={12} md={6} lg={4}
            className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.simodis_lbl}
                <label hidden={getCompareField("Simodis")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
              <TextField
                //disabled={!isEditableMode}
                variant="outlined"
                value={vendorDetail.simodis || ""}
                onChange={handleChange("simodis")}
                error={getErrorState("simodis")}
                inputProps={{
                  maxLength: FieldsLengthConstants.simodis,
                }}
                onBlur={handleOnBlur("simodis")}
              />
            </Grid>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={6} lg={4} >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_detail_bankdetails_extra1upload_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <div className={classes.fileWrapper}>
                <FileUpload
                  editable={isEditableMode}
                  requestNumber={vendorDetail.RequestNumber}
                  userfile={vendorDetail.Extra1File}
                  attachmentType={FileUploadTypes.ExtraDocument_1}
                ></FileUpload>
              </div>
            </Grid>
          </Grid> */}
          {/* <Grid item xs={12} sm={12} md={6} lg={4} >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_detail_bankdetails_extra2upload_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <div className={classes.fileWrapper}>
                <FileUpload
                  editable={isEditableMode}
                  requestNumber={vendorDetail.RequestNumber}
                  userfile={vendorDetail.Extra2File}
                  attachmentType={FileUploadTypes.ExtraDocument_2}
                ></FileUpload>
              </div>
            </Grid>
          </Grid> */}
          {isEditableMode && (
            <Grid item container xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.formTwoLbl}>
                  {translation.vendor_detail_bankdetails_bankdata_lbl}
                </span>
              </Grid>
              <Grid
                className={classes.formOneinputWrapper}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <div className={classes.addBtnWrapper}>
                  <Button onClick={handleAddBankDetails}>
                    <AddCircleIcon></AddCircleIcon>
                    {translation.vendor_detail_bankdetails_bankdata_addbtntxt}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </Grid>
        <div className={classes.legendSection}>
          <label className={classes.legendLbl}><span className={classes.addLbl}></span>Added</label>
          <label className={classes.legendLbl}><span className={classes.deleteLbl}></span>Deleted</label>
          <label className={classes.legendLbl}><span className={classes.modifiedLbl}></span>Modified</label>
        </div>
        <Grid container spacing={2} item xs={12} sm={12} md={11} lg={12}>
          <div className={classes.tblOuterBG}>
            <Paper>
              <TableContainer className={classes.tblContainer}>
                <Table
                  size="small"
                  stickyHeader
                  aria-label="sticky table"
                  style={{ minWidth: "100px" }}
                >
                  <TableHead className={classes.tblHeader}>
                    <TableRow>
                      {tableColumnData.map((column, index) => {
                        return (
                          <TableCell style={{ minWidth: "100px" }}>
                            {column.name}
                          </TableCell>
                        );
                      })}
                      {<TableCell style={{ minWidth: "79px" }}></TableCell>}

                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.tblBody}>
                    {vendorDetail.bankDetailList &&
                      vendorDetail.bankDetailList.map((row, i) => {
                        return (
                          <TableRow className={row.modifiedStatus == 2 ? classes.deletedDataRow : ""}
                            key={row.id}>
                            <TableCell className={getRowColorClass(row)}>
                              {row.bankCountry}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "BeneficiaryAccName") ? classes.editedCell : ""}>
                              {row.beneficiaryAccName}
                            </TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "BenificiaryAddress") ? classes.editedCell : ""}>
                              {row.beneficiaryAddress}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "BenificiaryAcNo") ? classes.editedCell : ""}>
                              {row.bankAccNumber}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "BankAcKeyCode") ? classes.editedCell : ""}>
                              {row.bankAcKeyDesc}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "AccountCurrencyCode") ? classes.editedCell : ""}>
                              {row.accCurrency}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "BankNameCode") ? classes.editedCell : ""}>
                              {row.bankName}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankAccNumber, "BankAddress") ? classes.editedCell : ""}>
                              {row.bankAddress}</TableCell>
                            {/* <TableCell>{row.sortCode}</TableCell> */}
                            <TableCell className={getBankGridCompareField(row.swiftCode, "BankSwiftCode") ? classes.editedCell : ""}>
                              {row.swiftCode}</TableCell>
                            <TableCell className={getBankGridCompareField(row.ibanCode, "BankIbanCode") ? classes.editedCell : ""}>
                              {row.ibanCode}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankBranch, "BankBranch") ? classes.editedCell : ""}>
                              {row.bankBranch}</TableCell>
                            <TableCell className={getBankGridCompareField(row.bankNumber, "BankNumber") ? classes.editedCell : ""}>
                              {row.bankNumber}</TableCell>
                            <TableCell align="center">
                              {isEditableMode && <div className={classes.editBtn}>
                                <button hidden={row.modifiedStatus == 2}
                                  onClick={(e) => onBankDetailEditClick(row)}
                                >
                                  <Tooltip title="Edit" placement="bottom-start"><EditIcon></EditIcon></Tooltip>
                                  <span className={classes.editBtnTxt}>
                                    {/* {
                                      translation.vendor_detail_bankdetails_table_edit_btn
                                    } */}
                                  </span>
                                </button>
                              </div>}
                              {isEditableMode && <div className={classes.rejectBtn}>
                                <button hidden={row.modifiedStatus == 2}
                                  // disabled={!row.isActive}
                                  onClick={(e) => onBankDetailDeleteClick(row)}
                                >
                                  <Tooltip title="Remove" placement="bottom-start"><HighlightOffOutlinedIcon></HighlightOffOutlinedIcon></Tooltip>
                                  <span className={classes.rejectBtnTxt}>
                                    {
                                      // translation.vendor_detail_bankdetails_table_delete_btn
                                    }
                                  </span>
                                </button>
                              </div>}
                              {!isEditableMode && <div className={classes.viewBtn}>
                                <button
                                  // disabled={!row.isActive}
                                  onClick={(e) => onBankDetailEditClick(row)}
                                >
                                  <Tooltip title="View" placement="bottom-start"><ViewIcon></ViewIcon></Tooltip>
                                </button>
                              </div>}
                            </TableCell>

                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              {vendorDetail.bankDetailList &&
                vendorDetail.bankDetailList.length === 0 && (
                  <div>
                    {translation.vendor_detail_bankdetails_table_nodata}
                  </div>
                )}
            </Paper>
          </div>
        </Grid>
      </Grid>

      <BankDetailDialog
        open={openBankDialog}
        handleClose={handleBankDetailClose}
        countries={getAllowedCountries()}
        bankDetailData={selectedBankData}
        isAddBankDetail={isAddBankData}
        isViewBankDetail={vendorDetail.requestStatusId !== RequestStatus.Initial}
      ></BankDetailDialog>
    </div>
  );
}
